module.exports = "<footer class=\"main-footer fixed-btm\">\r\n        Copyright Kashio INC - 2017-2022\r\n</footer>"